import React, { FC, useMemo, useState } from 'react';
import {
  ArrowBottomDenseIcon,
  ArrowTopDenseIcon,
  CheckIcon,
  Dropdown,
  DropdownItem,
  DropdownList,
} from '@rubin-dev/goblin';
import { NetworkIcon, NetworkIconEnum } from '@shared/ui';
import { Network } from '@apolloGenerated';
import cls from './styles.module.scss';
import cx from 'classnames';

type Props = {
  size?: 'large' | 'small';
  fullWidth?: boolean;
  hasUsd?: boolean;
  network: Network;
  currentNetwork: Network | NetworkIconEnum;
  onChange(network: Network | NetworkIconEnum): void;
};
export const TokenSelect: FC<Props> = ({
  size = 'small',
  fullWidth,
  network,
  currentNetwork,
  onChange,
  hasUsd = false,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const dropDownList = useMemo(() => {
    if (network === 'BTC') {
      return [NetworkIconEnum.Btc];
    }

    if (network === 'ETH') {
      return [NetworkIconEnum.Usdt, NetworkIconEnum.Eth];
    }

    return [NetworkIconEnum.Usdt, NetworkIconEnum.Trx];
  }, [network]);

  const onChangeHandler = (item: Network | NetworkIconEnum) => {
    setIsOpen(false);
    onChange(item);
  };

  return (
    <Dropdown
      value={isOpen}
      onChange={setIsOpen}
      className={cls[`group_${size}`]}
      targetSlot={
        <div className={cx(cls.group, cls.group_border)}>
          <NetworkIcon width={16} height={16} network={currentNetwork} />
          {currentNetwork}
          <div className={cls.icon}>
            {isOpen ? <ArrowTopDenseIcon /> : <ArrowBottomDenseIcon />}
          </div>
        </div>
      }
      placement="bottom-start"
      fullWidth={fullWidth}
      width={200}
    >
      <DropdownList>
        {hasUsd && (
          <DropdownItem
            fullWidth
            className={cls.item}
            onClick={() => onChangeHandler(NetworkIconEnum.Usd)}
          >
            <div className={cls.group}>
              <NetworkIcon network={NetworkIconEnum.Usd} width={24} height={24} />
              {NetworkIconEnum.Usd}
              {currentNetwork === NetworkIconEnum.Usd && (
                <CheckIcon className={cls.iconCheck} color={'#4067CA'} />
              )}
            </div>
          </DropdownItem>
        )}
        {dropDownList &&
          dropDownList.map((item) => (
            <DropdownItem
              key={item}
              fullWidth
              className={cls.item}
              onClick={() => onChangeHandler(item)}
            >
              <div className={cls.group}>
                <NetworkIcon network={item} width={24} height={24} />
                {item}
                {currentNetwork === item && (
                  <CheckIcon className={cls.iconCheck} color={'#4067CA'} />
                )}
              </div>
            </DropdownItem>
          ))}
      </DropdownList>
    </Dropdown>
  );
};
